import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when a user creates a canvas',
  name: 'canvas_created',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The id of the library',
      name: 'library_id',
      required: false,
      type: 'string',
    },
    {
      description: 'The id of the board',
      name: 'board_id',
      required: false,
      type: 'string',
    },
    {
      description: 'The location from which the canvas was created',
      name: 'source',
      required: false,
      type: 'enum',
      values: [
        'board',
        'library',
        'general_library',
        'asset_selection_bar',
        'all_content_header',
        'canvases',
        'try_canvas_cta',
        'board_canvas_open',
        'all_content_canvas_open',
      ],
    },
  ],
};

export default META;
